const EMAIL_API_URL =
  "https://api.shubhpaisa.com/api/ShubhPaisa/SendEmail";

const KEY_ID = "9b57265fbb8521f1ac3a52010aa9680s";
const KEY_SECRET = "4rdl13a65635bc6360d62d12ea82b9d28b342157a345654eb5ed8eab2addc830";

export const sendEmail = async ({
  to = [],
  triggerId,
  variables = {},
}) => {
  try {
    const response = await fetch(EMAIL_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to,
        keyid: KEY_ID,
        keySecret: KEY_SECRET,
        triggerId,
        variables,
      }),
    });

    if (!response.ok) {
      throw new Error(`Email API failed: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Email API Error:", error);
    throw error;
  }
};
